import React from "react";
import {browserHistory } from "react-router";

const StaticComponent = ({ title, content }) => {
  const contentClickHandler = (e) => {
    const targetLink = e.target.closest(".route-link");
    if (!targetLink) return;
    e.preventDefault();
    browserHistory.push(targetLink.getAttribute("href"));
  };
  return (
    <div
      className="static-component-homepage"
      onClick={contentClickHandler}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default StaticComponent;